import theme from '@/shared/styles/themes/default.theme'
import { SxProps } from '@mui/material'

const styles = {
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    height: '100vh',
    [theme.breakpoints.down('md')]: {
      height: 'auto'
    }
  } as SxProps,

  onBoardingContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    height: '100vh',
    alignSelf: 'flex-start'
  } as SxProps
}

export default styles
